import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const GetCataloguesAction = createAsyncThunk("getCatalogues",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.playbookQuestions, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const GetCataloguesSlice = createSlice({
    name: "getCatalogues",
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        GetCataloguesReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [GetCataloguesAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [GetCataloguesAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [GetCataloguesAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { GetCataloguesReset } = GetCataloguesSlice.actions
export default GetCataloguesSlice.reducer